import {FirebaseMessageRoomType} from 'types'

export const MESSAGE_ENV_KEY: Record<FirebaseMessageRoomType, string> = {
  'chat': process.env.FIREBASE_COLLECTION_MESSAGE_FORKYGRAM_ROOM!,
  'giftshop': process.env.FIREBASE_COLLECTION_MESSAGE_GIFTSHOP_ROOM!,
  'system': process.env.FIREBASE_COLLECTION_MESSAGE_SYSTEM_ROOM!,
}
